import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

const Advantages = ({advantages}) => {
    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);
    
    return (
        <div className="features-bg">
            <Container>
                <div className={!mobile ? "text-left pb-2" : "padding-feature"}>
                    <Row>
                        {advantages.map((res,index) => (
                            <Col key={res[0]} md="6" className={index === advantages.length ? "mb-5" : "mb-2"}>
                                <div className="service-card-feature mt-2">
                                    <Row>
                                        <Col md="2">
                                            <img className="storage-icon" src={res[2]} alt="" />
                                        </Col>
                                        <Col md="10">
                                            <p className="card-head pt-3">{res[0]}</p>
                                            <p className="card-body">{res[1]}</p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>
        </div>
    );
}

export default Advantages;
